import Request, { SimpleResponse } from './Request';

class System {
    static ImportPlan = (data: any): SimpleResponse => { return Request.DoPost('system/import/plan', data, 'multipart/form-data') as unknown as SimpleResponse; };
    static ImportActual = (data: any): SimpleResponse => { return Request.DoPost('system/import/actual', data, 'multipart/form-data') as unknown as SimpleResponse; };
    static DownloadActualModel = (): Promise<void> => Request.DoDownload('system/import/model/actual', 'ModelActual.xlsx');
    static DownloadPlanModel = (): Promise<void> => Request.DoDownload('system/import/model/plan', 'ModelPlan.xlsx');
    static ExportActual = (year: number, month: number): Promise<void> => Request.DoDownload(`system/export/actual/${year}/${month}`, `ExportActual_${year}-${month}.xlsx`);
    static ExportPlan = (year: number, month: number): Promise<void> => Request.DoDownload(`system/export/plan/${year}/${month}`, `ExportPlan_${year}-${month}.xlsx`);
}

export default System;
